<template>
    <div>
        <div 
            class="d-flex"
            :class="msgError ? 'mb-2':''">
            <v-text-field 
                density="compact"
                variant="outlined"
                label="Discount code"
                placeholder="Discount code"
                v-model="discountCode"
                :error-messages="msgError">
            </v-text-field>
            <v-btn 
                class="ml-5"
                @click="applyDiscount">
                Apply
            </v-btn>
        </div>
        <div 
            class="d-flex"
            :class="msgError1 ? 'mb-2':''"
            v-if="formCombinationFreeShipping">
            <v-text-field 
                density="compact"
                variant="outlined"
                label="Discount code shipping"
                placeholder="Discount code shipping"
                v-model="discountCode1"
                :error-messages="msgError1">
            </v-text-field>
            <v-btn 
                class="ml-5"
                @click="applyDiscount1">
                Apply
            </v-btn>
        </div>

        <div v-if="message && message.combination">
            <p class="text-success">
                Great news! This voucher can be combined with a free-shipping voucher. Go ahead and enter your free-shipping voucher now.
            </p>
        </div>
    </div>
    
</template>

<script setup>
    import { ref, defineEmits } from 'vue'
    import api from '@/api'
    import { storeToRefs } from 'pinia'
    import { useUserStore } from '@/store/user'

    const emit = defineEmits(['updateDataDiscount'])
    const props = defineProps(['shippingcost'])

    const userStore = useUserStore()
    const { user } = storeToRefs(userStore)
    
    const discountCode = ref('')
    const discountCode1 = ref('')
    const loading = ref(false)

    const msgError = ref('')
    const msgError1 = ref('')

    const formCombinationFreeShipping = ref(null)

    const message = ref(null)

    async function applyDiscount(){
    msgError.value = ''
    message.value = null
        loading.value = true

        let url = 'discount/check'
        if(user.value){
            url = 'discount/l/check'
        }

        await api.post(url, {
            code: discountCode.value,
            cost_shipping: props.shippingcost.price
        })
        .then((resp) => {
            loading.value = false
            if(resp.data){
                if(resp.data.data.status){
                    emit('updateDataDiscount', resp.data.data)
                    message.value = resp.data.data

                    if(resp.data.data.combination == 'free shipping'){
                        formCombinationFreeShipping.value = true
                    }
                } else {
                    msgError.value = resp.data.data.message
                    emit('updateDataDiscount', {})
                    formCombinationFreeShipping.value = false
                }
            } else {
                msgError.value = resp.data.data.message
                emit('updateDataDiscount', {})
                formCombinationFreeShipping.value = false
            }
        })
        .catch((err) => {
            loading.value = false
            if(err.response && err.response.status){
                if(err.response.status == 422){
                    msgError.value = 'The code field is required.' 
                } else {
                    msgError.value = err.response.data.message
                }
            } else {
                msgError.value = 'Internal server error' 
            }
            formCombinationFreeShipping.value = false
        })

    }
    
    async function applyDiscount1(){
        msgError1.value = ''
        message.value = null
        loading.value = true

        let url = 'discount/check'
        if(user.value){
            url = 'discount/l/check'
        }

        await api.post(url, {
            code: discountCode1.value,
            cost_shipping: props.shippingcost.price
        })
        .then((resp) => {
            loading.value = false
            if(resp.data){
                if(resp.data.data.status){
                    emit('updateDataDiscount', resp.data.data)
                    message.value = resp.data.data
                } else {
                    msgError1.value = resp.data.data.message
                    discountCode.value = ''
                    emit('updateDataDiscount', {})
                }
            } else {
                msgError1.value = resp.data.data.message
                discountCode.value = ''
                emit('updateDataDiscount', {})
            }
        })
        .catch((err) => {
            loading.value = false
            if(err.response && err.response.status){
                if(err.response.status == 422){
                    msgError1.value = 'The code field is required.' 
                } else {
                    msgError1.value = err.response.data.message
                }
            } else {
                msgError1.value = 'Internal server error' 
            }
            discountCode.value = ''
        })

    }
</script>

<style scoped>
    
</style>